import React, { useEffect, useState } from "react";
import Icons from "../../Assets/icons/Icons";
import style from "./Navbar.module.css";
import { Link, NavLink } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { contactNumber } from "../../Constants/constant";
import UseResize from "../../components/Hooks/UseResize";
import pages from "../../pages/pages"
import { Logo } from "../../Assets/svgs";


const Navbar = () => {
  // const location = useLocation();
  const { header, desktop } = UseResize();
  const [opentray, setopentray] = useState(false);
  const menu = pages.filter(
  (page) => !page?.route.includes("admin") && !page.route.includes(":")
);

  

  useEffect(() => {
    AOS.init({
      once: false,
      easing: "linear",
    });
  }, []);

  useEffect(() => {
    if (opentray) {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: false,
      });
      AOS.refresh();
    } else {
      const animatedElements = document.querySelectorAll("navAni");
      animatedElements.forEach((el) => {
        el.setAttribute("data-aos", "fade-out");
      });
      AOS.refresh();
    }
  }, [opentray]);

  useEffect(() => {
    if (desktop) {
      setopentray(true);
    } else {
      setopentray(false);
    }
  }, [desktop]);

  return (
    <nav className={`${style.nav} ${header ? style.active_header : ""}`}>
      <div className={`${style.wrapper} mainWrapper`}>
        <NavLink to="/" onClick={() => {
          if (!desktop) setopentray(false);
        }}>
          <div className={style.logo}>
            <img src={Logo} alt="lexrae logo" />
          </div>
        </NavLink>
        <div className={`${style.menu} ${opentray ? style.active : ""}`}>
          <div className={`${style.menuHeader} desktop`}>
            <Link
              to="/"
              className={`${style.headerlogo} ${opentray ? style.active : ""} navAni`}
              data-aos="fade-in"
              onClick={() => setopentray(false)}
            >
              <img src={Logo} alt="Lexrae Support logo" />
            </Link>
            <div className={style.times} onClick={() => setopentray(false)}>
              {Icons.times}
            </div>
          </div>
          <ul>
            {menu.map((e, index) => (
              <li
                key={e.name}
                className={`${opentray ? style.block  : ""} navAni` }
                data-aos={opentray ? "fade-right" : "fade-out"}
                data-aos-delay={`${index * 200}`}
              >
                <NavLink
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                  to={e.route}
                  onClick={() => {
                    if (!desktop) setopentray(false);
                  }}
                >
                  {e.name}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className={style.menuContact}>
            {Icons.phone}
            <p>{contactNumber}</p>
          </div>
          <div className={`${style.footer} mobile`}>
            <div className={style.privacy}>
              <a
                href="https://drive.google.com/file/d/1HhfWWS2H4sed0JO739JE20k5_bH84e9W/view?usp=sharing" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <a
                href="https://drive.google.com/file/d/10yMYZLioeiqf5wy9IJmQm5h_QziCyisY/view?usp=drive_link" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Terms & Conditions
              </a>
            </div>
            <p>© 2025 Lexrae support - All rights reserved</p>
          </div>
        </div>
        <div className={`${style.openTray} mobile`}>
          <div onClick={() => setopentray(true)}>{Icons.menu}</div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
